export default __webpack_public_path__ + "static/media/pic9.5066a7a9.jpg";